interface Props {
  tag?: React.ReactNode;
  heading: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  id?: string;
  zoomDelay?: number;
}

const SectionShell: React.FC<Props> = ({
  heading,
  subtitle,
  tag,
  children,
  id,
  zoomDelay = 0,
}) => (
  <section className="relative" id={id}>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 overflow-x-scroll">
      <div className="pt-32 pb-12 md:pt-40 px-2">
        {/* Section Header */}
        <div className="text-center">
          {tag}
          <h2
            className="h2 font-extrabold leading-tighter tracking-tighter mb-4"
            data-aos="zoom-y-out"
            data-aos-delay={zoomDelay}
          >
            {heading}
          </h2>
          {subtitle && (
            <div className="mx-w-3xl mx-auto">
              <p
                className="text-xl text-gray-600 mb-8"
                data-aos="zoom-y-out"
                data-aos-delay={zoomDelay + 150}
              >
                {subtitle}
              </p>
            </div>
          )}
        </div>
        {children}
      </div>
    </div>
  </section>
);

export default SectionShell;
